import React, { Component } from 'react';
import { connect } from 'react-redux';

import Button from 'jbc-front/components/Button';

import { reduxForm } from 'redux-form';
import { EMPLOYEE_FORM } from 'src/constants/FormNames';
import { FileField } from '../../jbc-front/components/Form';
import { Question, Upload } from 'jbc-front/components/icons';
import { ErrorsSection } from 'src/components';
import { INSERT_BATCH_CSV, EMPLOYEES_LIST } from 'src/constants/EndpointUrls';
import isUseOtherApp from 'src/utils/JbcId';
import { getSelectOptions } from 'src/reducers/selectOptions';
import { useTranslation, withTranslation } from 'react-i18next';
import i18next from 'i18next';

// Reducer
import { getItemErrors } from 'src/reducers/common/itemReducer';
import { REDUCER_NAME, importEmployeeCsv } from 'src/reducers/employees/employees';

import AnyJobRunning from './components/AnyJobRunning';
import AnyApiRunning from './components/AnyApiRunning';
import HelpUpdateBatchCsv from './HelpUpdateBatchCsv';
import FileImportDescription from './components/FileImportDescription';
import styles from './styles/FileImport.scss';

class FileImportUpdate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showHelp: false
    };
  }

  render() {
    const { submitting, handleSubmit, errors } = this.props;

    return (
      <div className={styles.wrap}>
        <div className={styles.head}>{i18next.t('features.Employees.UpdateBatchCsv.Upload_steps')}</div>
        <div className={styles.body}>
          <form onSubmit={handleSubmit}>
            <ErrorsSection errors={errors} />

            <dl className={styles.label}>
              <dt className={styles.number}>1</dt>
              <dd className={styles.detail}>
                <div>
                  {i18next.t('features.Employees.UpdateBatchCsv.Please_click')}<a href={EMPLOYEES_LIST} className="u-txt-link" target="_blank">
                    {i18next.t('features.Employees.UpdateBatchCsv.here')}
                  </a>
                  <span
                    className={styles.helpWrap}
                    onClick={() => {
                      this.setState({ showHelp: !this.state.showHelp });
                    }}
                    role="presentation"
                  >
                    <Question />
                    {this.state.showHelp && (
                      <HelpUpdateBatchCsv
                        hide={() => {
                          this.setState({ showHelp: false });
                        }}
                      />
                    )}
                  </span>
                  {i18next.t('features.Employees.UpdateBatchCsv.to_download_employee_information')}
                </div>
              </dd>
            </dl>

            <dl className={styles.label}>
              <dt className={styles.number}>2</dt>
              <dd className={styles.detail}>
                {i18next.t('features.Employees.UpdateBatchCsv.Put_the_information_of_the_employee_you_want_to_change_in_the_downloaded_CSV_file_using_the_instructions_below_as_reference')}
                <div className={styles.warning}>
                  <span className={styles.warningTitle}>{i18next.t('features.Employees.UpdateBatchCsv.Cautions')}</span>
                  <ul className={styles.warningList}>
                    <li>
                      {i18next.t('features.Employees.UpdateBatchCsv.The_following_items')}<span className={styles.requiredText}>{i18next.t('features.Employees.UpdateBatchCsv.You_are_currently_on_a_free_planrequired')}</span>{i18next.t('features.Employees.UpdateBatchCsv.to_be_filled_in')}
                      <ul className={styles.requireList}>
                        <li>{i18next.t('features.Employees.UpdateBatchCsv.Staff_code')}</li>
                        <li>{i18next.t('features.Employees.UpdateBatchCsv.Lastname')}</li>
                        <li>{i18next.t('features.Employees.UpdateBatchCsv.Name')}</li>
                        <li>{i18next.t('features.Employees.UpdateBatchCsv.First_day_at_work')}</li>
                        <li>{i18next.t('features.Employees.UpdateBatchCsv.Payroll_Rules_Group')}</li>
                        {/* <li>{i18next.t('features.Employees.UpdateBatchCsv.If_commuting_allowance_information_is_to_be_registered')}</li>
                        <li>{i18next.t('features.Employees.UpdateBatchCsv.commuting_allowance')}</li>
                        <li>{i18next.t('features.Employees.UpdateBatchCsv.If_dependents_information_is_to_be_registered')}</li>
                        <li>{i18next.t('features.Employees.UpdateBatchCsv.dependents')} {i18next.t('features.Employees.UpdateBatchCsv.relationship')}</li>
                        <li>{i18next.t('features.Employees.UpdateBatchCsv.dependents')} {i18next.t('features.Employees.UpdateBatchCsv.Lastname1')}</li>
                        <li>{i18next.t('features.Employees.UpdateBatchCsv.dependents')} {i18next.t('features.Employees.UpdateBatchCsv.name')}</li>
                        <li>{i18next.t('features.Employees.UpdateBatchCsv.dependents')} {i18next.t('features.Employees.UpdateBatchCsv.birthday')}</li> */}
                        <li>{i18next.t('features.Employees.UpdateBatchCsv.payment_setting_salary_by_bank_transfer1')} {i18next.t('features.Employees.UpdateBatchCsv.If_amount_is_to_be_registered')}</li>
                        <li>{i18next.t('features.Employees.UpdateBatchCsv.Payment_setting_salary_by_bank_transfer1')} {i18next.t('features.Employees.UpdateBatchCsv.transfer_recipient')}</li>
                        <li>{i18next.t('features.Employees.UpdateBatchCsv.Payment_setting_salary_by_bank_transfer1')} {i18next.t('features.Employees.UpdateBatchCsv.transfer_source')}</li>
                        {/* <li>{i18next.t('features.Employees.UpdateBatchCsv.payment_setting_bonus_by_bank_transfer1')} {i18next.t('features.Employees.UpdateBatchCsv.If_amount_is_to_be_registered')}</li>
                        <li>{i18next.t('features.Employees.UpdateBatchCsv.Payment_setting_bonus_by_bank_transfer1')} {i18next.t('features.Employees.UpdateBatchCsv.transfer_recipient')}</li>
                        <li>{i18next.t('features.Employees.UpdateBatchCsv.Payment_setting_bonus_by_bank_transfer1')} {i18next.t('features.Employees.UpdateBatchCsv.transfer_source')}</li> */}
                      </ul>
                    </li>
                    <li>
                      {i18next.t('features.Employees.UpdateBatchCsv.Employee_information_that_matches_the_staff_code_will_be_updated')}<span className={styles.requiredText}>
                        {i18next.t('features.Employees.UpdateBatchCsv.so_please_enter_the_correct_staff_code')}
                      </span>
                    </li>
                    <li>
                      {i18next.t('features.Employees.UpdateBatchCsv.If_you_update_while_leaving_the_field_blank')}<span className={styles.requiredText}>
                        {i18next.t('features.Employees.UpdateBatchCsv.please_note_that_the_data_will_be_deleted')}
                      </span>
                    </li>
                    {isUseOtherApp && (
                      <li>
                        {i18next.t('features.Employees.UpdateBatchCsv.When_the_user_to_be_updated_is_also_registered_in_other_JOBCAN_services')}
                        <span className={styles.requiredText}>
                          {i18next.t('features.Employees.UpdateBatchCsv.If_you_change_your_first_name_last_name_or_email_address_it_will_be_automatically_reflected_in_the_other_JOBCAN_services_you_are_using')}
                        </span>
                      </li>
                    )}
                  </ul>
                </div>
              </dd>
            </dl>

            <dl className={styles.label}>
              <dt className={styles.number}>3</dt>
              <dd className={styles.detail}>
                <p className={styles.text}>{i18next.t('features.Employees.UpdateBatchCsv.Select_and_upload_your_completed_file')}</p>
                <FileField name="employee_csv" className={styles.input} />
              </dd>
            </dl>

            <Button as="button" primary type="submit" disabled={submitting} icon={<Upload size={16} />} widthWide>
              {i18next.t('features.Employees.InsertBatchCsv.upload')}
            </Button>
          </form>
        </div>
      </div>
    );
  }
}

let FormContainer = withTranslation()(reduxForm({
  form: EMPLOYEE_FORM,
  enableReinitialize: true
})(({ submitting, handleSubmit, errors }) => (
  <FileImportUpdate submitting={submitting} handleSubmit={handleSubmit} errors={errors} />
)));

FormContainer = connect(
  state => ({
    errors: getItemErrors(REDUCER_NAME, state),
    initialValues: { encoding: 'Windows-31J' }
  }),
  dispatch => ({
    onSubmit: data => dispatch(importEmployeeCsv(data, 'update'))
  })
)(FormContainer);

const UpdateBatchCsv = ({ anyJobRunning, anyApiRunning }) => {
  const { t } = useTranslation();
  return (
    <div>
      {anyJobRunning && <AnyJobRunning />}
      {anyApiRunning && <AnyApiRunning />}
      <div className="l-title-wrap">
        <h1 className="m-title-main">{t('features.Employees.UpdateBatchCsv.Update_employee_information')}</h1>
        <p className="m-title-main-note">
          {t('features.Employees.UpdateBatchCsv.You_can_update_all_registered_employee_information_at_once')}<br />※ {t('features.Employees.UpdateBatchCsv.To_add_new_employee_information')}<a
            href={INSERT_BATCH_CSV}
            className="u-txt-link"
          >
            {t('features.Employees.UpdateBatchCsv.click_here')}
          </a>
        </p>
        <br />
        <p className={styles.requiredText}>
          {t('features.Employees.UpdateBatchCsv.The_number_of_employees_that_can_be_updated_in_bulk_is_limited_to_500')}<br />
          {t('features.Employees.UpdateBatchCsv.To_update_more_than_500_people_please_update_multiple_times')}
        </p>
      </div>
      <FormContainer />
      <div className={styles.description}>
        <FileImportDescription update />
      </div>
    </div>
  )
};

export default connect(state => ({
  anyJobRunning: getSelectOptions(state, 'anyJobRunning'),
  anyApiRunning: getSelectOptions(state, 'anyApiRunning')
}))(UpdateBatchCsv);
